import Vue from 'vue';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

import { BootstrapVue, BootstrapVueIcons, BOverlay } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component('b-overlay', BOverlay);

